import React from "react";
import { useStats } from "react-instantsearch";

const translations = {
  en: { result: "result", results: "results" },
  fr: { result: "résultat", results: "résultats" },
};

export default function CustomStats() {
  const { nbHits } = useStats();
  const lang = document.documentElement.lang || "en";
  const t = translations[lang] || translations.en;

  return (
    <p className="search-stats h4">
      {nbHits} {nbHits === 1 ? t.result : t.results}
    </p>
  );
}
